/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IGynicHistory {
  id?: string;
  menarche?: string | null;
  cycleStart?: number | null;
  cycleEnd?: number | null;
  loss?: string | null;
  interMenstrualBleed?: string | null;
  pain?: string | null;
  vaginalDischarge?: string | null;
  papSmear?: string | null;
  contraception?: boolean | null;
  contraceptionDetails?: string | null;
  active?: boolean | null;
  cursor?: number;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<IGynicHistory> = {
  contraception: false,
  active: false,
};
